import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { bindActionCreators } from "redux";
import Form from "../../components/forms/EmailTemplateForm";
import { saveTemplate, withRedirect } from "../../CroActions";
import { breadcrumbs } from "../../../../actions/appActions";
import { noop } from "lodash";
import { encodeBase64 } from "../../CroUtils";

const selector = formValueSelector("emailTemplateForm");

const todayFormatted = () => {
  const today = new Date();
  return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
};

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [{ label: "Emailová šablona" }],
  type: selector(state, 'type'),
  isNew: true,
  initialValues: {
    validFrom: todayFormatted()
  },
});

const onSubmit = (values, dispatch, props) => {
  const submitValues = {
    ...values,
    content: values.content ? encodeBase64(values.content) : "",
    id: "",
    version: ""
  };
  return withRedirect(saveTemplate, "/administrator/sablony/email")(submitValues, dispatch, props);
};

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators({ onSubmit, breadcrumbs }, dispatch),
  accept: noop,
  reject: noop,
  send: noop,
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);